export class TemplateMultiLineInspection {
    id = 0;
    description = '';
}
